
import { initializeApp } from "firebase/app";

import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

import {
  getFirestore
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDA2Xq9sRvRuVZVkeIH8Q6d6JB9Pv_Dkss",
  authDomain: "vila-pinto.firebaseapp.com",
  projectId: "vila-pinto",
  storageBucket: "vila-pinto.firebasestorage.app",
  messagingSenderId: "669076509625",
  appId: "1:669076509625:web:5cb058223684593590dc68",
  measurementId: "G-N3JXY8LEY7"
};

const app = initializeApp(
  firebaseConfig,
  "vila-pinto"
);

export const auth = getAuth(app);

setPersistence(
  auth,
  browserLocalPersistence
);

export const db = getFirestore(app);

export default app;